interface BuildSeoAPParams {
  hotelId: string
  locale: string
}

export const buildSeoApPath = ({hotelId, locale}: BuildSeoAPParams) =>
  [`/Hotel`, hotelId, locale].join('/')
